/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfTransactionSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateTransactionCommand, type CreateTransactionCommand, type PaginatedListOfTransactionSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ExportRequestBuilderRequestsMetadata, type ExportRequestBuilder } from './exportEscaped/index.js';
// @ts-ignore
import { TransactionsItemRequestBuilderNavigationMetadata, TransactionsItemRequestBuilderRequestsMetadata, type TransactionsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /transactions
 */
export interface TransactionsRequestBuilder extends BaseRequestBuilder<TransactionsRequestBuilder> {
    /**
     * The export property
     */
    get exportEscaped(): ExportRequestBuilder;
    /**
     * Gets an item from the ApiSdk.transactions.item collection
     * @param id Unique identifier of the item
     * @returns {TransactionsItemRequestBuilder}
     */
     byId(id: Guid) : TransactionsItemRequestBuilder;
    /**
     * GetTransactions
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfTransactionSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<TransactionsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfTransactionSummary | undefined>;
    /**
     * CreateTransaction
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateTransactionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetTransactions
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TransactionsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateTransaction
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateTransactionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetTransactions
 */
export interface TransactionsRequestBuilderGetQueryParameters {
    criteria?: string;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const TransactionsRequestBuilderUriTemplate = "{+baseurl}/transactions{?Criteria*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const TransactionsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TransactionsRequestBuilderNavigationMetadata: Record<Exclude<keyof TransactionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: TransactionsItemRequestBuilderRequestsMetadata,
        navigationMetadata: TransactionsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    exportEscaped: {
        requestsMetadata: ExportRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const TransactionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TransactionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfTransactionSummaryFromDiscriminatorValue,
        queryParametersMapper: TransactionsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: TransactionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateTransactionCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
